import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, ConvertDateToDB } from 'src/globals';
import { getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { booking_returndata } from 'src/types/booking_returndata';
import { BusyService } from '../_services/busy.service';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { MenuItem } from 'primeng/api/menuitem';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { cBookingfee } from 'src/types/bookingfee';
import { bookingfee_returndata } from 'src/types/bookingfee_returndata';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';
import { tag } from 'src/types/tag';
import { tag_returndata } from 'src/types/tag_returndata';

@Component({
  selector: 'app-bookinglist',
  templateUrl: './bookinglist.component.html',
  styleUrls: ['./bookinglist.component.css']
})
export class BookinglistComponent  implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;

  BookingDateEnd: Date;

  PreviousBookingDate: Date;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  FromDate: Date = new Date();
  ToDate: Date = new Date();
  //PageLinks: any;
  //currentPageIndex: number = 4;

  cols: any[];
  mode: any = "StartDate";
  chosentags: tag[] = [];
  tags: tag[] = [];

  BookingsTitle: string = "";
  criteria: boolean = false;
  searchCriteria: string = "";

  showCriteriaButtonText: string = "Show Criteria";

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get useMobileView(): boolean {
    if (this.screenwidth <= 768) return true;
    return this.screenwidth <= 1024 && this.screenheight > this.screenwidth;
  }

  get isBookingDateToday(): boolean {
    if (!this.BookingDate) return false;
    const today = new Date();
    return this.BookingDate.getFullYear() === today.getFullYear()
      && this.BookingDate.getMonth() === today.getMonth()
      && this.BookingDate.getDate() === today.getDate();
  }

  //@ViewChild('resourceTable') dataTable: any;
  //@ViewChild('table', { static: true }) dataTable!: any;
  
  constructor(
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService,
    private route: ActivatedRoute) {
      
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("HOME", user)){
          this.AccessAllowed = true;
        }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }

  maskMobile(MobileIn)
  {
    //only show last 4 digits
    if(MobileIn != null && MobileIn.length > 4)
    {
      let last4 = MobileIn.slice(-4);
      let masked = "**** **** " + last4;
      return masked;
    }
  }

  refreshData(){

    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    this.http.get(bmxurl + "RegenerateBookingMin/" + this.VenueID + "/" + dateChosen).subscribe(response => {
      this.httpResponse =  (response as any)
      if(this.httpResponse.succeeded)
      {
        this.loadgrid(false);
      }
    }, error => { 
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting date, error:' + error.messages[0]});
    });

  }

  showBookings(){

    //Check if BookingDateEnd is less than or equal to BookingDate plus 1 month
    if (this.BookingDateEnd.getTime() > this.BookingDate.getTime() + 31 * 24 * 60 * 60 * 1000)
    {
      this.messageService.add({severity:'error', summary:'Date Range Error', detail:'The maximum date range allowed is 31 days. Please adjust the end date.'});
      return;
    }
    else
    {
      //this.busyService.busy();
      //this.isDisabled = false;

      if(this.BookingDate.getTime() == this.BookingDateEnd.getTime())
      {
        this.BookingsTitle = "Bookings for " + this.BookingDate.toLocaleDateString('en-GB');
      }
      else
      {
        this.BookingsTitle = "Bookings between " + this.BookingDate.toLocaleDateString('en-GB') + " and " + this.BookingDateEnd.toLocaleDateString('en-GB');
      }
      this.loadgrid(false);
    }
  }

  showCriteria(){
    this.criteria = !this.criteria;
    this.showCriteriaButtonText = this.criteria ? "Hide Criteria" : "Show Criteria";
  }

  getSearchResults() {
    if (this.searchCriteria.trim() === '') return;
    localStorage.removeItem("SearchResults");
    let crit = this.searchCriteria.trim().replace("/", "-").replace("/", "-");
    crit = encodeURIComponent(crit);
    this.searchCriteria = "";
    this.router.navigate(['/search'], { queryParams: { crit: crit } });
  }

  hideCriteria(){
    this.criteria = false;
    this.showCriteriaButtonText = this.criteria ? "Hide Criteria" : "Show Criteria";
  }

  ngOnInit(): void {
    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    this.BookingDate = new Date();
    this.BookingDateEnd = new Date();

    this.BookingsTitle = "Bookings for " + this.BookingDate.toLocaleDateString('en-GB')

    if(this.route.snapshot.paramMap.get('startdate') != null && this.route.snapshot.paramMap.get('startdate') != 'null')
    {
      this.BookingDate = new Date(this.route.snapshot.paramMap.get('startdate'));
    }

    this.loadTags(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let menuItems: MenuItem[];
    let userid = localStorage.getItem("SmartUserID");

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    //this.busyService.busy();
    
        this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
          this.httpResponse =  (response as venuesettings_returndata)
          if(this.httpResponse.succeeded)
          {
            localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
    
            this.httpResponse.data.venueSettings.forEach(element => {
              localStorage.setItem(element.name, element.value);
            });

            this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
            this.loadgrid(false, false);
          }
          else{
            this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
        });


    this.http.get(bmxurl + "bookingfee/" + this.VenueID).subscribe(response => {
      this.httpResponse = (response as bookingfee_returndata)
      if (this.httpResponse.succeeded)
      {
        if(this.httpResponse.data != null)
        {
          let BookingFee: cBookingfee = {
            id: (this.httpResponse.data as cBookingfee).id,
            venueid: (this.httpResponse.data as cBookingfee).venueid,
            disabled: (this.httpResponse.data as cBookingfee).disabled,
            bfid: (this.httpResponse.data as cBookingfee).bfid,
            name: (this.httpResponse.data as cBookingfee).name,
            isdefault: (this.httpResponse.data as cBookingfee).isdefault,
            bfpublicapply: (this.httpResponse.data as cBookingfee).bfpublicapply,
            bfadminapply: (this.httpResponse.data as cBookingfee).bfadminapply,
            bfpublicshowtext: (this.httpResponse.data as cBookingfee).bfpublicshowtext,
            bfpublictext: (this.httpResponse.data as cBookingfee).bfpublictext,
            bfpublictype: (this.httpResponse.data as cBookingfee).bfpublictype,
            bfadmintype: (this.httpResponse.data as cBookingfee).bfadmintype,
            bfpublicfee: (this.httpResponse.data as cBookingfee).bfpublicfee,
            bfpublicmin: (this.httpResponse.data as cBookingfee).bfpublicmin,
            bfpublicmax: (this.httpResponse.data as cBookingfee).bfpublicmax,
            bfadminfee: (this.httpResponse.data as cBookingfee).bfadminfee,
            bfadminmin: (this.httpResponse.data as cBookingfee).bfadminmin,
            bfadminmax: (this.httpResponse.data as cBookingfee).bfadminmax,
            bookingfeeappliestomemberspublic: (this.httpResponse.data as cBookingfee).bookingfeeappliestomemberspublic,
            bookingfeeappliedonmembershippurchasespublic: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasespublic,
            bookingfeeappliestomembersadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliestomembersadmin,
            bookingfeeappliedonmembershippurchasesadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasesadmin,
            colour: (this.httpResponse.data as cBookingfee).colour
          };

          localStorage.setItem("VenueBookingFee", JSON.stringify(BookingFee));
        }
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee'});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee, error:' + error.messages[0]});
    });


    this.cols = [
      { field: 'bookingIdHR', header: 'Sales ID' },
      { field: 'createddateCSV', header: 'Created Date' },
      { field: 'startTimeCSV', header: 'Start Date/Time' },
      { field: 'name', header: 'Name' },
      { field: 'email', header: 'Email' },
      { field: 'phone', header: 'Phone' },
      { field: 'packageName', header: 'Package' },
      { field: 'resourcestring', header: 'Resource' },
      { field: 'guests', header: 'Guests' },
      { field: 'admissions', header: 'Admissions' },
      { field: 'total', header: 'Total' },
      { field: 'outstanding', header: 'Outstanding' },
      { field: 'extraslist', header: 'Extras' },
      { field: 'allergy', header: 'Allergy' },
      { field: 'notes', header: 'Notes' },
      ];
  }

  loadTags(showdisabled: boolean) {
    this.http.get(bmxurl + "TagList/" + this.VenueID + "/" + showdisabled).subscribe(response => {
      this.tags = (response as tag_returndata).data;
    }, error => {
    });
  }

  editdata(ID){
    localStorage.addItem("listScreenBookings", JSON.stringify(this.ListBookings));
    localStorage.addItem("listScreen", "TRUE");
    localStorage.addItem("homeScreenNumberOfRecords", 0);
    localStorage.addItem("homeScreenCurrentPage", );
    localStorage.addItem("startdate", this.BookingDate);
    localStorage.addItem("enddate", this.BookingDateEnd);

    this.router.navigateByUrl("/editbooking/" + ID);
  }

  editdatanew(ID){
    localStorage.setItem("listScreenBookings", JSON.stringify(this.ListBookings));
    localStorage.setItem("listScreen", "TRUE");
    localStorage.setItem("startdate", this.BookingDate.toJSON());
    localStorage.setItem("enddate", this.BookingDateEnd.toJSON());
    localStorage.setItem("ListTitle", this.BookingsTitle);
    localStorage.setItem("ListTags", JSON.stringify(this.chosentags));

    this.router.navigateByUrl("/editbooking/" + ID);
  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled, false);
  }

  disableData(BookingID)
  {
    if (confirm("Are you sure you want to disable this booking?"))
     {
        this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + BookingID).subscribe(response => {
          this.CreateUpdateResponse = response
          if(this.CreateUpdateResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Disabled', detail:'Booking successfully disabled'});
            //this.loadgrid(false);
            this.busyService.idle();
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Booking'});
        })
      }
  }

  undisableData(BookingID)
  {
    this.http.get(bmxurl + "enablebooking/" + this.VenueID + "/" + BookingID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Enabled', detail:'Booking successfully enabled'});
        //this.loadgrid(false);
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred enabling this Booking'});
    })
  }

  abandonBooking(BookingID)
  {
    let abandonBooking: any = {
      bookingid: BookingID,
      jwt: null
    }
    //Booking Exists, abandon it
    this.http.post(bmxurl + "abandonbooking/", abandonBooking).subscribe(response => {
      this.messageService.add({severity:'success', summary:'Abandoned', detail:'Booking abandoned successfully.'});
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to abandon booking.'});
    });
  }

  loadgrid(showdisabled: boolean, runClose: boolean = true)
  {
    //this.busyService.busy();

    if (localStorage.getItem("startdate") != null && localStorage.getItem("startdate") != "")
    {
      this.BookingDate = new Date(localStorage.getItem("startdate"));
      localStorage.removeItem("startdate");
    }

    if (localStorage.getItem("enddate") != null && localStorage.getItem("enddate") != "")
    {
      this.BookingDateEnd = new Date(localStorage.getItem("enddate"));
      localStorage.removeItem("enddate");
    }

    if (localStorage.getItem("ListTitle") != null && localStorage.getItem("ListTitle") != "")
    {
      this.BookingsTitle = localStorage.getItem("ListTitle")!;
      localStorage.removeItem("ListTitle");
    }

    if (localStorage.getItem("ListTags") != null && localStorage.getItem("ListTags") != "")
    {
      this.chosentags = (JSON.parse((localStorage.getItem("ListTags"))) as tag[]);
      localStorage.removeItem("ListTags");
    }

    localStorage.removeItem("listScreen") 


    let searchCrit = {
      venueid: this.VenueID,
      startdate: ConvertDateToDB(this.BookingDate),
      enddate: ConvertDateToDB(this.BookingDateEnd),
      tags: this.chosentags,
      disabled: showdisabled,
      created: true
    }

    this.busyService.busy();

    this.http.post(bmxurl + "/BookingList",  searchCrit).subscribe(response => {
      try{
        this.CreateUpdateResponse = (response as booking_returndata);

        //Get VenueDate
        this.ListBookingsGlobal = this.CreateUpdateResponse.data;

        var thisYear: any = this.BookingDate.getFullYear();
        var thisMonth: any = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
        var thisDay: any = ('00' + this.BookingDate.getDate()).slice(-2);
        var fullDate: any = thisYear + thisMonth + thisDay;

        let venueDate: string =  this.VenueID + "_" + fullDate;

        this.hideCriteria();

        this.ListBookings = this.ListBookingsGlobal.filter(obj => obj.inProgress == false);
        this.ListBookings.forEach(element => {
          element.startTimeCSV = this.formatDateForExcel(element.startTime);
          element.createddateCSV = this.formatDateForExcel(element.createddate);
        });

        this.busyService.idle();

        this.bookingsInProgress = this.ListBookingsGlobal.filter(obj => obj.inProgress == true).length;
        this.totalBookingsToday = this.ListBookingsGlobal.filter(obj => obj.inProgress == false).length;;

        //this.setCurrentPage(2);
        this.busyService.idle();
      }
      catch (error){
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  emailConf(BookingID)
  {
    this.http.get<any>(bmxurl + "confirmationemail/" + this.VenueID + "/" + BookingID).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Sent Booking Confirmation.'})
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: 'Could not send Booking Confirmation: ' + response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send Booking Confirmation'});
    })
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + element.bookingId).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        //this.loadgrid(false);
        this.busyService.idle();
      }
    }, error => {

    })
    });

  }

  doneDate(){

    this.inProgress = false;

    //this.loadgrid(false);
    this.busyService.idle();

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();
  }

  exportData()
  {


  }

  customSort(event: any) {
    event.data.sort((a: any, b: any) => {
      let result = 0;

      if (event.field === 'resourcestring') {
        const res1 = a.resourcestring ?? '';
        const res2 = b.resourcestring ?? '';
        result = res1.localeCompare(res2);
        if (result === 0) {
          const d1 = new Date(a.startTime).getTime();
          const d2 = new Date(b.startTime).getTime();
          result = d1 < d2 ? -1 : d1 > d2 ? 1 : 0;
        }
      } else {
        const val1 = a[event.field];
        const val2 = b[event.field];
        if (val1 == null && val2 != null) result = -1;
        else if (val1 != null && val2 == null) result = 1;
        else if (val1 == null && val2 == null) result = 0;
        else if (typeof val1 === 'string' && typeof val2 === 'string') result = val1.localeCompare(val2);
        else result = val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
      }

      return event.order * result;
    });
  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

}

